
define('ldsh!modules/lp_leads/templates/defaults_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-overlay-container popUp-leads">\n  <!-- header -->\n  <div class="ed-opt-toolbar ed-modal-header">\n    <h4 class="ed-modal-title" data-i18n="integration.defaultsPopupTitle">Campos por defecto</h4>\n\n    <button data-dismiss="modal" class="close js-close" type="button" aria-hidden="true">\n      <i class="ri-close-line"></i>\n    </button>\n  </div>\n\n  <!-- contenido -->\n  <div class="ed-opt-content ed-modal-content">\n\n    <ul class="ed-leads-list">\n      ';
 for (var i=0; i<fields.length; i++){
        var field = fields[i],
            value = this.model.get(fields[i]),
            className = /^[0-9\\:\\-\\.]*$/.test(value) ? "font-secondary" : "";
      ;
__p += '\n      <li class="ed-leads-list-item">\n      <b class="lead-title" data-i18n="integration.' +
((__t = ( field )) == null ? '' : __t) +
'">' +
((__t = ( field )) == null ? '' : __t) +
'</b>\n      <span class="lead-info ' +
((__t = ( className )) == null ? '' : __t) +
'">' +
((__t = ( value  )) == null ? '' : __t) +
'</span>\n      </li>\n      ';
 } ;
__p += '\n    </ul>\n\n  </div>\n\n  <!-- botonera -->\n  <div class="ed-opt-btnbar ed-modal-footer">\n    <button data-i18n="" type="button" class="ed-btn ed-btn-sec js-close" data-i18n="common.okButton">Aceptar</button>\n  </div>\n\n</div>\n';

}
return __p
};});

